import React, { memo, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AntdConfigProvider from '@providers/AntdConfigProvider';
import AxiosConfigProvider from '@providers/AxiosConfigProvider';
import SessionProvider from '@providers/Session';
import keycloak from '@services/keycloak';
import { IKeycloak } from '@providers/Keycloak/KeycloakContext';
import KeycloakProvider from '@providers/Keycloak';
import { AlarmToastNotification } from '@components/Notification';
import Routes from './Routes';
import PortalSpinner from './components/PortalSpinner';
import GlobalStyle from './styles/global';
import i18n from './i18n';
import './styles/main.less';

const MemoizedAlarmToastNotification = memo(() => (
  <AlarmToastNotification openNotification />
));

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<PortalSpinner />}>
      <KeycloakProvider
        i18next={i18n}
        initOptions={{
          onLoad: 'login-required',
          checkLoginIframe: false,
        }}
        keycloak={keycloak as IKeycloak}
      >
        <AntdConfigProvider>
          <AxiosConfigProvider>
            <SessionProvider>
              <GlobalStyle />
              <MemoizedAlarmToastNotification />
              <Routes />
            </SessionProvider>
          </AxiosConfigProvider>
        </AntdConfigProvider>
      </KeycloakProvider>
    </Suspense>
  </BrowserRouter>
);

export default App;
